/* eslint-disable no-undef */
import "../../../webparts/cam.scss";
import * as React from "react";
import RootStore from "../stores/root-store";
import Headers from "../../../../../../redux/Actions/Headers/Header";
import { RootStoreContext } from "../root-store-context";
import { ConfigApi } from "../api/base/ConfigApi";
import { App, ConfigProvider } from "antd";
import { useDispatch } from "react-redux";
import { useEffect } from "react";
import { Main } from "./Main";

export interface IIndexProps {
  apiConfig: ConfigApi;
}

const CAMApp = (props: IIndexProps): React.ReactElement => {
  const dispatch = useDispatch();

  const [store] = React.useState(() => new RootStore(props.apiConfig));

  useEffect(() => {
    dispatch(
      Headers.setHeader({
        title: "CAM - Communication Automation Manager",
        actions: [],
      })
    );

    return () => {
      dispatch(Headers.resetHeader());
    };
  }, [dispatch]);

  return (
    <ConfigProvider
      theme={{
        token: {
          colorPrimary: "#2563eb",
          borderRadius: 10,
          fontSize: 15,
          colorText: "#172033",
          colorTextSecondary: "#64748b",
          colorBorder: "#d8e0ec",
        },
        components: {
          Collapse: {
            colorBorder: "transparent",
            headerBg: "#ffffff",
            paddingSM: 6,
            padding: 0,
          },
          Button: {
            borderRadius: 10,
            colorPrimary: "#2563eb",
            colorPrimaryHover: "#1d4ed8",
            colorPrimaryActive: "#1e40af",
            colorPrimaryTextActive: "#ffffff",
            controlHeightLG: 44,
          },
          Typography: {
            fontSize: 16,
          },
          Drawer: {
            padding: 16,
            paddingLG: 16,
            paddingXS: 16,
          },
          Tabs: {
            itemSelectedColor: "#2563eb",
            itemHoverColor: "#2563eb",
            inkBarColor: "transparent",
            itemColor: "#64748b",
            titleFontSize: 15,
            cardBg: "transparent",
            colorBgContainer: "transparent",
          },
        },
      }}
    >
      <RootStoreContext.Provider value={store}>
        <div className="cam__page">
          <div className="cam__container">
            <App>
              <Main />
            </App>
          </div>
        </div>
      </RootStoreContext.Provider>
    </ConfigProvider>
  );
};

export default CAMApp;